import type {
  PortfolioAssessmentRequest,
  PortfolioAssessmentResource,
} from "api/generated";
import { AssessmentModel } from "api/generated";
import { mapShallowTeacher } from "shared/mappers";
import type {
  AssessmentFormData,
  StudentAssessment,
  StudentAssessmentValue,
} from "portfolio/types";

export const studentAssessmentFromDto = (
  resource: PortfolioAssessmentResource,
): StudentAssessment => {
  const assessedBy = resource.assessed_by
    ? mapShallowTeacher(resource.assessed_by)
    : null;

  return {
    id: resource.id,
    type: resource.type,
    explanation: resource.explanation,
    value: resource.value as StudentAssessmentValue,
    assessedAt: resource.assessed_at ? new Date(resource.assessed_at) : null,
    allowRetry: resource.allow_retry,
    assessedByShortage: resource.assessed_by_shortage,
    assessedBy,
    assessorDisplayName:
      resource.assessed_by_shortage ?? assessedBy?.fullName ?? null,
    meta: {
      canEdit: resource.meta.can_edit,
      canDelete: resource.meta.can_delete,
    },
  };
};

export const assessmentFormDataToDto = (
  formData: AssessmentFormData,
): PortfolioAssessmentRequest => {
  const isSimple = formData.type === AssessmentModel.simple;

  return {
    type: formData.type as PortfolioAssessmentRequest["type"],
    value: isSimple ? formData.value === "true" : formData.value,
    allow_retry: formData.allowRetry,
    explanation: formData.explanation,
  } as PortfolioAssessmentRequest;
};
